module.exports = __webpack_public_path__ + "static/instagram-9322d6d1a569684bc8a83a0576a15b24.png";